  document.addEventListener("DOMContentLoaded", function () {
    const tabs = document.querySelectorAll(".tab-btn");
    const experts = document.querySelectorAll(".expert-card");

    const modal = document.getElementById("expertModal");
    const modalImg = document.getElementById("modal-img");
    const modalName = document.getElementById("modal-name");
    const modalRole = document.getElementById("modal-role");
    const modalBio = document.getElementById("modal-bio");
    const closeBtn = document.querySelector(".modal .close");

    // 💡 SHOW TABS LOGIC
    function showTab(tab) {
      experts.forEach((expert) => {
        const expertTabs = expert.dataset.tab.split(",").map((t) => t.trim());
        expert.classList.toggle("active", expertTabs.includes(tab));
      });

      if (window.expertsSwiper) {
        window.expertsSwiper.slides.forEach((slide) => {
          const slideTabs = slide.dataset.tab.split(",").map((t) => t.trim());
          slide.style.display = slideTabs.includes(tab) ? "" : "none";
        });

        // Stop Swiper transform after filtering
        window.expertsSwiper.wrapperEl.style.transform = "none";
        window.expertsSwiper.update();
      }
    }

    // 💡 HANDLE TAB CLICK
    tabs.forEach((btn) => {
      btn.addEventListener("click", () => {
        tabs.forEach((b) => b.classList.remove("active"));
        btn.classList.add("active");
        showTab(btn.dataset.tab);
      });
    });

    // ✅ Auto-select 3rd tab (if available)
    if (tabs.length >= 3) {
      tabs.forEach((tab) => tab.classList.remove("active"));
      const thirdTab = tabs[2];
      thirdTab.classList.add("active");
      showTab(thirdTab.dataset.tab);
    } else if (tabs.length > 0) {
      tabs[0].classList.add("active");
      showTab(tabs[0].dataset.tab);
    }

    // 💡 EXPERT MODAL (popup)
    document.querySelectorAll(".learn-more").forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();
        modalImg.src = link.dataset.img;
        modalName.textContent = link.dataset.name;
        modalRole.textContent = link.dataset.role;
        modalBio.textContent = link.dataset.bio;
        modal.style.display = "block";
      });
    });

    closeBtn.addEventListener("click", () => (modal.style.display = "none"));
    window.addEventListener("click", (e) => {
      if (e.target === modal) modal.style.display = "none";
    });

    // 💡 SWIPER INIT
    function initSwiper() {
      if (window.innerWidth <= 768) {
        if (!window.expertsSwiper) {
          window.expertsSwiper = new Swiper(".swiper-container", {
            slidesPerView: 1.8,
            spaceBetween: 10,
            loop: true,
            centeredSlides: true,
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            scrollbar: {
              el: ".swiper-scrollbar",
              draggable: true,
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            breakpoints: {
              480: {
                slidesPerView: 1.2,
                centeredSlides: true,
              },
              768: {
                slidesPerView: 2,
                centeredSlides: true,
              },
              1024: {
                slidesPerView: 5,
                centeredSlides: false,
              },
            },
          });

          // Refresh Swiper content based on active tab
          const activeTab = document.querySelector(".tab-btn.active");
          if (activeTab) {
            showTab(activeTab.dataset.tab);
          }
        }
      } else {
        if (window.expertsSwiper) {
          window.expertsSwiper.destroy(true, true);
          window.expertsSwiper = null;

          // Show all experts when Swiper is not active
          experts.forEach((expert) => (expert.style.display = ""));
        }
      }
    }

    // Initial call and on window resize
    initSwiper();
    window.addEventListener("resize", initSwiper);
  });